module.exports = __webpack_public_path__ + "static/media/yellow-signs-mobiles-2.8fcffd5f.jpg";